import axios from 'axios';
import Session from '../../../../api/session';
import Title from '../../../components/Title';
import Navbar from '../../../../layout/logged_in/Navbar';
import Sidenav from '../../../../layout/logged_in/Sidenav';
import Button from '../../../components/Button';
import { backendUrl } from '../../../../config';

const SeoExport = () => {

    const handleExport = async () => {
        try {
            const response = await axios.get(`${backendUrl}/a/seo/export`, {
                withCredentials: true,
                responseType: 'blob'
            });

            // Check if response is actually a blob (file) or JSON error
            if (response.data.type === 'application/json') {
                const text = await response.data.text();
                const error = JSON.parse(text);
                console.error('Export error:', error);
                window.showToast('WCL20511');
                return;
            }

            // Validate blob size
            if (response.data.size === 0) {
                console.error('Empty file received');
                window.showToast('WCL20511');
                return;
            }

            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'seo-export.xlsx');
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);
            
            // Show success toast
            window.showToast('WCL20510');
        } catch (error) {
            console.error('SEO Export Error:', error);
            window.showToast('WCL20511');
        }
    };

    return (
        <>
            <Session />
            <Title set="SEO Export" />
            <div className="App">
                <div className="antialiased">
                    <Navbar />
                    <Sidenav />
                    <main className="p-4 lg:pl-[270px] h-screen max-w-screen-2xl pt-20 z-0 mx-auto">
                        <h2 className="text-3xl text-kb-400 tracking-wide font-light py-7 uppercase">SEO Export</h2>
                        <div className="border border-dashed border-gray-200 bg-gray-50 p-6 space-y-4 max-w-lg">
                            <p className="text-gray-700">Download a CSV file containing SEO data for all active products, collections, fabrics, categories, and the homepage.</p>
                            <Button size="sm" text="DOWNLOAD CSV" onClick={handleExport} />
                        </div>
                    </main>
                </div>
            </div>
        </>
    );
};

export default SeoExport;
